import ModuleSubNav from './ModuleSubNav.vue'

export default ModuleSubNav
export { ModuleSubNav }